import { IconFileInvoice } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { MantineLinkCell } from "../../../../../mantine/mrt/components/cell/MantineLinkCell";
import type { PPAContract } from "../../PPAContractPage.types";

export function getNameColumn(): MRT_ColumnDef<PPAContract> {
  return {
    accessorKey: "name",
    header: "Vertragsname",
    enableColumnFilter: false,
    size: 300,
    Cell: ({ renderedCellValue, row }) => (
      <MantineLinkCell
        IconComponent={IconFileInvoice}
        renderedCellValue={renderedCellValue}
        url={row.original.contract_file_link}
      />
    )
  };
}
